/** @jsx isolateComponent */

import { ReactNode } from 'react';

import { Colors } from '@zapier/theme';
import { Text } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';

type DowngradeFormProps = {
  /** The content to display in the form */
  children: ReactNode;
  /** Text to display in the header */
  header: string;
  /** The plan name to downgrade to */
  planName: string;
};

const containerCss = {
  margin: '20px auto',
  padding: 20,
  backgroundColor: Colors.white,
  border: `1px solid ${Colors.adamantium}`,
  maxWidth: 600,
};

const headerCss = {
  textAlign: 'center' as 'center',
};

const sectionCss = {
  marginTop: 40,
};

export const DowngradeForm = (props: DowngradeFormProps) => (
  <div css={containerCss}>
    <section css={headerCss}>
      <h1>
        <Text type="subsection-head">downgrade to {props.planName}</Text>
      </h1>
      <h2>
        <Text type="main-head">{props.header}</Text>
      </h2>
    </section>

    <section css={sectionCss}>{props.children}</section>
  </div>
);
